import React, { memo, ReactNode } from 'react';

import { useNavigate } from '@plasma/ui.application.router';
import { Icon } from '@plasma/ui.general.icon';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import themes from './themes';
import * as styled from './top-bar-themed.styles';

export interface TopBarThemedProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  topHeading: string;
  showHome?: boolean;
}

type Props = TopBarThemedProps & ThemeOverride;

function TopBarThemed(props: Props) {
  const {
    children,
    className,
    style,
    size,
    themeMode,
    topHeading,
    showHome = true,
  } = props;

  const companyId = sessionStorage.getItem('companyID');
  const superUserRole = sessionStorage.getItem('superUserRole');
  const navigate = useNavigate();

  const handleGoHome = () => {
    superUserRole === 'Ts-admin' ? companyId?.length && superUserRole === 'Ts-admin' ? navigate('/home-screen') : navigate('/create-new-project')
      : navigate('/home-screen');
  };

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.TopBarThemed className={`top-bar-themed ${className ?? ''}`.trim()} style={style} showHome={showHome}>
        {showHome && (
          <Icon
            name={'Home'}
            title="Go Home"
            className="home-icon"
            onClick={() => handleGoHome()}
          />
        )}

        {children ? <div className="spacer" /> : null}

        <div className="heading">
          {topHeading}
        </div>

        {children}
      </styled.TopBarThemed>
    </ThemeProvider>
  );
}

export default memo(TopBarThemed) as unknown as typeof TopBarThemed;
